import { FaChartBar, FaCircleLeft, FaCodePullRequest, FaGears, FaPercent, FaPlaneDeparture, FaTicketSimple } from "react-icons/fa6";

const MenuOwner = [
  {
    label: "Owner Dashboard",
    type: "menu-title",
  },
  {
    label: "Dashboard",
    to: "owner-dashboard",
    icon: <FaChartBar />,
  },
  {
    label: "Customer Spending",
    to: "report/customer-spending-report",
    icon: <FaChartBar />,
  },
  {
    label: "Remaining Packages",
    to: "report/remaining-customer-packages",
    icon: <FaChartBar />,
  },
  {
    label: "Report",
    to: "report",
    icon: <FaChartBar />,
  },
  {
    label: "Vacation",
    to: "employee/vacation",
    icon: <FaPlaneDeparture />,
  },
  {
    label: "Customer",
    type: "menu-title",
  },
  {
    label: "Package Request",
    to: "customer/package-request",
    icon: <FaCodePullRequest />,
  },
  {
    label: "Customer Voucher",
    to: "customer/vouchers",
    icon: <FaTicketSimple />,
  },
  {
    label: "Customer Discount",
    to: "customer/discounts",
    icon: <FaPercent />,
  },
  {
    label: "Stock",
    type: "menu-title",
  },
  {
    label: "Stock In",
    to: "stock/stockin",
    icon: <FaCircleLeft />,
  },
  {
    label: "User Settings",
    type: "menu-title",
  },
  {
    label: "Setting",
    icon: <FaGears />,
    to: "setting/general",
    children: [],
  },
];

export default MenuOwner;
